import { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useI18n } from '@/hooks/useI18n'

export const CountryRoute: React.FC = () => {
    const { countryCode } = useParams<{ countryCode: string }>()
    const navigate = useNavigate()
    const { t } = useI18n()

    useEffect(() => {
        if (!countryCode) {
            navigate('/')
            return
        }

        // The I18nProvider now handles country switching automatically based on the URL
        // Just redirect to home page
        navigate('/', { replace: true })
    }, [countryCode, navigate])

    // Show loading while redirecting
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
            fontSize: '1.2rem',
            color: 'var(--mantine-color-text)'
        }}>
            {t('countryRoute.switching', { country: countryCode?.toUpperCase() })}
        </div>
    )
} 